import axios from 'axios'

export const getClientThemes = async (clientName: string) => {
  const themes = await axios.get(
    `https://buffup-web-sdk.core.buffup.net/buffup-web-sdk/${clientName}/themes.json`
  )

  return themes.data
}
